export const fields = [

    { key: 'name', label: "Nama", _style:'min-width:100px' },
    { key: 'is_opd', label: "OPD", _style:'min-width:50px' },
    { key: 'opd', label: "OPD Terlibat", _style:'min-width:150px' },
    { key: "created_at", label: "Dibuat", _style:'min-width:100px'},
    { key: "action", label: 'Aksi', _style: 'min-width:75px'}
   
]
